import React, {useState, useEffect} from 'react';
import {Main,Axios,Swal,} from '../../../Helpers/importacionesComunes'
import { Button, Card, Checkbox, Input, Spinner, Typography,Option, Select } from '@material-tailwind/react';
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { Textarea } from '@material-tailwind/react';
import {Cerrar} from './Cerrar';
import { v4 as uuidv4 } from 'uuid';
import { CopiarTexto } from '../../../componentes/CopiarTexto';

//const regex_solo_numeros = /^[0-9]+([.])?([0-9][0-9]?)?$/;
const regex_solo_numeros = /^(\d+)?([.]\d{0,2})?$/;

export default function EventoValorForm({id_evento_valor,finalizarAltaOcopia,id_evento,detalle}){

    const [huboError,setHuboError]=useState(false)
    const [grabandoDatos,setGrabandoDatos]=useState(false)
    const [cargando,setCargando]=useState(false)
    const {esCelular} = useContextoGlobal();
    const [eventoValor,setEventoValor] = useState({
			 detalle: '',
             //valor_mp:'',
             valor_mp:0,
             valor:0, // 24/06/2026
             info_adicional: '',
			 templateejs: '',
             beca_id: '',
			 activo: false,
             matrimonio:false,
             mercadopago: true,
			 beca_activa: false,
             validar_dni_externos:false,
			// habilitar_inscripciones:false,
		  	 texto1: '',
			 texto2: '',
			 texto3: '',
			 texto4: '',
             id_evento,
             edad_desde:1,
             edad_hasta:99,
             tipo_persona:'todos' // uad,externo, todos
    })
    const [newKey,setNewKey]=useState(0); // Hay algún problema con material tailwind y requiere un re renderizado cada vez que cambia el valor del select
    let edades = generarEdades()
    const tiposPersona = ['uad','externo','todos'] // estos valores se van a validar en el backend, no hay abm por ahora lo manejamos con 3 valores standard por el momento
     
    useEffect(()=>{

        const buscarEventosValor = async ()=>{
            setCargando(true)
            try{
                setHuboError(false)
                const {data} = await Axios.get(`api/tablasgenerales/eventos/eventosvalor/info/${id_evento_valor}`) 
                const vector_rango_edad = data.rango_edad.split(",");
                setEventoValor({...data,
                                valor_mp:data?.valor_mp || 0,
                                valor:data?.valor || 0, // 24/06/2026
                                edad_desde:Number(vector_rango_edad[0]),
                                edad_hasta:Number(vector_rango_edad[1]),
                                tipo_persona:data?.tipo_persona || 'todos'})
                setCargando(false)
            }catch(err){
                setHuboError(true)
                setCargando(false)
            }            
        }

        if(id_evento_valor){
            buscarEventosValor()
        }

        },[id_evento_valor])


    const iniciarGrabar = (values)=>{
        let texto;
        let textoConfirmacion;
    
        if(!eventoValor?.detalle){
            alert('Falta ingresar una descripción en el campo detalle')
            return
        }

        // if(!eventoValor?.valor_mp){
        //     alert('Falta ingresar el valor')
        //     return
        // }

        // const valorNumerico = parseFloat(eventoValor.valor_mp);
    
        // if (isNaN(valorNumerico) || valorNumerico <= 0) {
        // alert('Debe ingresar un valor válido en el campo valor');
        // return;
        // }

        const val_mp = validaciones_importes(eventoValor?.valor_mp); // 24/06/2026

        if(!val_mp[0]){
            alert(val_mp[1])
            return 
        }

        const val_cash = validaciones_importes(eventoValor?.valor);

        if(!val_cash[0]){
            alert(val_cash[1])
            return 
        }


        if(!(eventoValor.edad_desde<eventoValor.edad_hasta)){
            alert('La (edad desde) debe ser menor a (edad hasta)')
            return
        }

        if(eventoValor?.beca_activa==1 && !eventoValor?.beca_id){
            alert('Falta ingresar el link de la beca')
            return
        }

        if (id_evento_valor){
            texto = `¿Confirma la modificación del evento valor ${eventoValor.detalle}(${id_evento_valor})?`
            textoConfirmacion = 'Si, modificar el evento valor'
        }else{
            texto = `¿Confirma la creación del nuevo evento valor?`
            textoConfirmacion = 'Si, crear el evento valor'
        }
    
        Swal.fire({
            text:texto,
            showCancelButton:true,
            confirButtonText:textoConfirmacion,
            cancelButtonText:'Cancelar'
        }).then(
            resultado=>{
                if (resultado.value){
                    grabarDatos(values)
                    .catch(err=>{
                        alert(err)
                    })
                }else{
                    console.log("Se canceló la modificación o creación de la asamblea")
                }
            }
        )
    }

    const grabarDatos = async (values)=>{
        let resultado;

        const rango_edad = `${eventoValor.edad_desde},${eventoValor.edad_hasta}` // en la base de datos tabla eventos_valor se graba el rango_edad con el formato n,m que es un string en donde n es (edad desde) y m (edad_hasta)
//        const objetoAgrabar = {...eventoValor,rango_edad,valor_mp:parseFloat(eventoValor.valor_mp)};
        const objetoAgrabar = {...eventoValor,rango_edad,valor_mp:parseFloat(eventoValor.valor_mp),valor:parseFloat(eventoValor.valor)}; // 24/06/2026
    
        setGrabandoDatos(true)
    
        try{
            if (id_evento_valor){
                resultado= await Axios.put(`/api/tablasgenerales/eventovalor/${id_evento_valor}`,objetoAgrabar)
                finalizarAltaOcopia(id_evento_valor)
            }else{
                resultado= await Axios.post(`/api/tablasgenerales/eventovalor`,objetoAgrabar)
                finalizarAltaOcopia(resultado.data.id_evento_valor)
            }
        }catch(err){    
    
            let mensaje_html_error;
    
            console.log('err.response.status',err.response.status)
    
            if(err.response.data.message){
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del evento valor</p><p>${err.response.data.message}</p>`
            }else{
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del evento valor </p><p>${err.response.data.message}</p>`
            }
    
            Swal.fire({
                html:mensaje_html_error,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })   
        
            setGrabandoDatos(false)
        }
    }

    if (huboError){
        return <Main center>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <span>Se produjo un error al cargar los datos para esta vista</span>
                    </div>
            </Main>
    }

    if(cargando){
        return <Main> 
                    <div className={`flex flex-col justify-center items-center h-[calc(100vh-10rem)] ${esCelular ? 'ml-40' : ''}`}>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
     }

     return <>
     {/* <Cerrar cerrar={()=>finalizarAltaOcopia(null)}/> */}
     {/* <Typography
        variant="h3"
        color="blue-gray"
        className="mb-1 font-medium "
    >
        {detalle}
    </Typography>                    
    <Typography
        variant="h4"
        color="blue-gray"
        className="mb-1 font-medium "
    >
        {id_evento_valor ? `Modifique un item (Id:${id_evento_valor})` : `Cree un nuevo item`}
    </Typography> */}
    <p style={{color:'red'}}>* Indica que el campo es obligatorio</p>
    <div className="flex flex-col w-full mt-4">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium "
        >
            Detalle:<span className='c-obl'></span>
        </Typography>
        <Input
            onChange={(e)=>{
                setEventoValor({...eventoValor,detalle:e.target.value})
            }}
            value={eventoValor.detalle || ''} 
            type='text' 
            color='black'
            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
            autoFocus={id_evento_valor ? false : true}
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />
    </div>
    {/* <div className="flex flex-col w-full mt-4">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium "
        >
            Valor en mercadopago:<span className='c-obl'></span>
        </Typography>
         <Input
            onChange={(e) => setEventoValor({ ...eventoValor, valor_mp: e.target.value })} 
            type="number" 
            value={eventoValor.valor_mp} 
            color='black'
            placeholder="Ingrese un monto" 
            maxLength={200}
            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />

    </div> */}
<div className="flex flex-col md:flex-row gap-4 w-full mt-4">
    
    <div className="flex flex-col w-full">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium"
        >
            Valor en mercadopago:<span className='c-obl'></span>
        </Typography>
        <Input
            onChange={(e) => setEventoValor({ ...eventoValor, valor_mp: e.target.value })} 
            type="number" 
            value={eventoValor.valor_mp} 
            onFocus={(e) => e.target.select()}           
            color='black'
            placeholder="Ingrese un monto" 
            maxLength={200}
            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />
    </div>

    <div className="flex flex-col w-full">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium"
        >
            Valor en efectivo:<span className='c-obl'></span>
        </Typography>
        <Input
            onChange={(e) => setEventoValor({ ...eventoValor, valor: e.target.value })} 
            type="number" 
            value={eventoValor.valor} 
            color='black'
            onFocus={(e) => e.target.select()}           
            placeholder="Ingrese un monto" 
            maxLength={200}
            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />
    </div>

</div>
    <div className='flex'>   
    <Checkbox
        label="Activo"
        title='Controla si el item aparece en la plataforma de eventos'
        ripple={false}
        checked={eventoValor.activo == 1} 
        onClick={(e)=>setEventoValor({...eventoValor,activo:eventoValor.activo==1 ? 0 : 1})}
        className='w-5 h-5'
    />
    <Checkbox
        label="Permitir becados"
        ripple={false}
        title="Habilita o deshabilita becas para éste item"
        checked={eventoValor.beca_activa == 1} 
        onClick={(e)=>setEventoValor({...eventoValor,beca_activa:eventoValor.beca_activa==1 ? 0 : 1})}
        className='w-5 h-5'
    />
    <Checkbox
        label="Validar DNI externos"
        ripple={false}
        checked={eventoValor.validar_dni_externos == 1} 
        title='Controla si para éste item se valida que el DNI externo se encuentre autorizado por un ministro uad'
        onClick={(e)=>{
            if(e.target.checked){
                alert('Recuerde que las autorizaciones de DNI se hacen en la aplicación de ministros y para tal fin debe habilitarse en dicha aplicación un formulario para cada evento en particular. Verifique que haya un formulario para éste evento')
            }
            setEventoValor({...eventoValor,validar_dni_externos:eventoValor.validar_dni_externos==1 ? 0 : 1})
        }}
        className='w-5 h-5'
    />
        <Checkbox
            label="Matromionio"
            ripple={false}
            title="Es inscripción matrimonial"
            checked={eventoValor.matrimonio == 1} 
            onClick={(e)=>setEventoValor({...eventoValor,matrimonio:eventoValor.matrimonio==1 ? 0 : 1})}
            className='w-5 h-5'
        />  

    </div>
    <div className="flex w-full mt-4 select-ui-data">
        <div>
            <Typography
                variant="small"
                color="blue-gray"
                className="mb-1 font-medium "
            >
                Tipo de público: 
            </Typography>
            <Select 
                label="Tipo de público:" 
                value={eventoValor.tipo_persona}	
                key={newKey} // Hay algún problema con material tailwind y requiere un re renderizado cada vez que cambia el valor del select
                onChange={(e)=>{
                    setEventoValor({...eventoValor,tipo_persona:e})
                    setNewKey(uuidv4())
                }}
                className=""
            >
                {tiposPersona.map((item) => (
                    <Option key={uuidv4()} value={item}>
                            {item?.toUpperCase()}
                    </Option>
                ))}
            </Select>
         </div>
     </div>     
    <div className="flex w-full mt-4 select-ui-data">
        <div>
            <Typography
                variant="small"
                color="blue-gray"
                className="mb-1 font-medium "
            >
                Edad desde: 
            </Typography>
            <Select 
                label="Edad desde:" 
                value={eventoValor.edad_desde}	
                key={newKey} // Hay algún problema con material tailwind y requiere un re renderizado cada vez que cambia el valor del select
                onChange={(e)=>{
                    setEventoValor({...eventoValor,edad_desde:e})
                    setNewKey(uuidv4())
                }}
                className=""
            >
                {edades.map((item) => (
                    <Option key={uuidv4()} value={item}>
                            {item}
                    </Option>
                ))}
            </Select>
         </div>
         <div>
         <Typography
             variant="small"
             color="blue-gray"
             className="mb-1 font-medium "
         >
             Edad hasta: 
         </Typography>
         <Select 
             label="Edad hasta:" 
             value={eventoValor.edad_hasta}	
             key={newKey} // Hay algún problema con material tailwind y requiere un re renderizado cada vez que cambia el valor del select
             onChange={(e)=>{
                 setEventoValor({...eventoValor,edad_hasta:e})
                 setNewKey(uuidv4())
             }}
             className=""
         >
             {edades.map((item) => (
                 <Option key={uuidv4()} value={item}>
                         {item}
                 </Option>
             ))}
         </Select>
         </div>
     </div> 
    <div className="flex flex-col w-full mt-4">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium "
        >
            Información adicional (Sólo para mercadopago):
        </Typography>
        <Input
            onChange={(e)=>{
                setEventoValor({...eventoValor,info_adicional:e.target.value})
            }}
            value={eventoValor.info_adicional || ''} 
            type='text' 
            color='black'
            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />
    </div>
    <div className="flex flex-col w-full mt-4">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium "
        >
            Token de la beca (Por ejemplo: 123456-abc):
        </Typography>
        <Input
            onChange={(e)=>{
                setEventoValor({...eventoValor,beca_id:e.target.value.trim()})
            }}
            value={eventoValor.beca_id || ''} 
            type='text' 
            color='black'
            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />
       {eventoValor.beca_id && <CopiarTexto className='mt-2 mb-2 w-full' titulo="Link de la beca para compartir:" link={`https://uadapi.uad.digital/documentos/privado/eventos/${eventoValor.beca_id}`}/>}
    </div>
    <div className="flex flex-col w-full mt-4">
        <Typography
            variant="small"
            color="blue-gray"
            className="mb-1 font-medium "
        >
            Plantilla HTML (Mail/Mensaje no standard enviado al inscribirse):
        </Typography>
        <Input
            onChange={(e)=>{
                setEventoValor({...eventoValor,templateejs:e.target.value.trim()})
            }}
            value={eventoValor.templateejs || ''} 
            type='text' 
            color='black'
            className="!border-t-blue-gray-200 focus:!border-t-gray-900"
            labelProps={{
                className: "before:content-none after:content-none",
            }}
        />
    </div>
    <div className='items-center flex justify-center space-x-2 mt-4'>
        <Button onClick={iniciarGrabar} type="submit">
            Grabar
        </Button>
        <Button color='red' onClick={()=>finalizarAltaOcopia(null)}>
            cancelar
        </Button>
    </div>
</>

}

const generarEdades = ()=>{

    let edades = [];
    for(let i=1;i<100;i++){
        edades.push(i)
    }

    return edades;
}

const validaciones_importes = (importe)=>{
        if(!importe){
            return [false,'Falta ingresar un importe']
        }

        const valorNumerico = parseFloat(importe);
    
        if (isNaN(valorNumerico) || valorNumerico <= 0) {
        return [false,'Debe ingresar un valor válido en los campos de importes']
        }

        return [true]
}